import React from 'react'
import { withApollo } from 'react-apollo'
import { Field } from 'react-final-form'
import classNames from 'classnames'

import { checkDocNumAvailabilityQuery } from '../../../lib/graphql/people'

const validateInput = (client, checkAvailability) => async (value) => {
  if (value && checkAvailability) {
    const {
      data: { checkDocNumAvailability: isAvailable },
    } = await client.query({
      query: checkDocNumAvailabilityQuery,
      variables: { docNum: value },
      fetchPolicy: 'network-only',
    })

    if (!isAvailable) {
      return 'Documento de identificação já cadastrado!'
    }
  }
}

const DocNumInput = ({
  name,
  label,
  helpText,
  client,
  checkAvailability,
  ...props
}) => (
  <Field name={name} validate={validateInput(client, checkAvailability)}>
    {({ input, meta }) => (
      <div className="field">
        {label && <label className="label">{label}</label>}

        <div className="control">
          <input
            {...input}
            {...props}
            className={classNames('input', {
              'is-danger': meta.touched && meta.error,
            })}
          />
        </div>

        {!meta.touched && helpText && <p className="help">{helpText}</p>}

        {meta.touched && meta.error && (
          <p className="help is-danger">{meta.error}</p>
        )}
      </div>
    )}
  </Field>
)

export default withApollo(DocNumInput)
